import { useSelector } from 'react-redux';
import { Box, Typography, Container } from '@mui/material';
import WidgetRenderer from '../components/widgets/WidgetRenderer';
import { getDashboardWidgets } from '../utils/dashboardWidgets';
import InviteBanner from '../components/dashboard/InviteBanner';

/**
 * Dashboard - Generic dashboard page (single page for all userTypes)
 * 
 * Phase 3-4: UserType-based widget rendering
 * Phase 5+: Permission-based widget rendering
 * 
 * Features:
 * - Single dashboard for ALL userTypes (user, company_owner, admin)
 * - Widget-based architecture (modular, extensible)
 * - UserType-based widgets (getDashboardWidgets)
 * - Responsive layout (DashboardLayout)
 * - Lazy loading (WidgetRenderer + React.Suspense)
 * 
 * Flow:
 * 1. Get user from Redux (authSlice)
 * 2. Get widgets for user userType (getDashboardWidgets)
 * 3. Render widgets (WidgetRenderer)
 * 
 * CRITICAL: This project uses React Router 5!
 * - Route: /dashboard (protected with PrivateRoute)
 * - All userTypes → same route, different widgets
 */
const Dashboard = () => {
  const { user } = useSelector((state) => state.auth);

  // Guard: User not loaded yet
  if (!user) {
    return (
      <Container maxWidth="xl">
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary">
            Yükleniyor...
          </Typography>
        </Box>
      </Container>
    );
  }

  // Get widgets for current user
  // Phase 3-4: UserType-based (user.userType)
  // Phase 5+: Permission-based (user.permissions)
  const widgets = getDashboardWidgets(user.userType, user);

  return (
    <Container maxWidth="xl">
      {/* Invite Banner - Show pending invites notification */}
      <InviteBanner />

      {/* Widget Renderer */}
      <WidgetRenderer widgets={widgets} />


    </Container>
  );
};

export default Dashboard;

